import { Box, Button, Stack, Typography } from "@mui/material";
import React from "react";
import { StandardCard } from "../Card";
import BackspaceIcon from "@mui/icons-material/Backspace";
import Masonry from "react-responsive-masonry";
import { INumberDialPadProps } from "./interface/NumberDialPad.types";
import { CustomButton } from "../CustomButton";
import { IPunchType } from "../../redux/shifts";
import { useTheme } from "@mui/material/styles";
export const NumberDialPad: React.FC<INumberDialPadProps> = (props) => {
  const { forOtp, onSave } = props;

  const [dialNumber, setDialNumber] = React.useState<string[]>([]);
  const dialNumbersArray: string[] = [
    "1",
    "2",
    "3",
    "4",
    "5",
    "6",
    "7",
    "8",
    "9",
    ".",
    "0",
    "del",
  ];

  const handleDialPadNumbers = (number: string) => () => {
    setDialNumber((prev) => {
      const updatedDialNumber =
        number === "del" ? prev.slice(0, -1) : [...prev, number];
      // if (updatedDialNumber.length === 4 && forOtp) {
      //   onSave();
      // }
      return updatedDialNumber;
    });
  };

  const handleAddNewShifts = (punchType: IPunchType) => {
    if (dialNumber.length !== 4 && !forOtp) return
    onSave(punchType, dialNumber.join(''))
  }

  const isLightMode = useTheme().palette.mode === "light";

  return (
    <StandardCard
      sx={{
        height: "100%",
        display: "flex",
        flexDirection: "column",
        justifyContent: "center",
        alignItems: "center",
        gap: 2,
      }}
    >
      <Typography variant="h2" fontWeight={"700"}>
        {forOtp ? "Enter Your PIN" : "Tip Amount"}
      </Typography>

      <Box
        sx={{
          display: "flex",
          justifyContent: "center",
          alignItems: "center",
          fontWeight: "bold",
          // color: "#fff",
          gap: 1,
        }}
      >
        {forOtp ? (
          [...Array(4)].map((_, index) => {
            const pin = !!dialNumber[index];
            return (
              <Typography variant="h2" key={index}>
                {pin ? dialNumber[index] : "*"}
              </Typography>
            );
          })
        ) : (
          <Typography variant="h1" letterSpacing={0.5}>
            {dialNumbersArray.length > 0 ? dialNumber.join("") : "0.00"}
          </Typography>
        )}
      </Box>

      <Masonry columnsCount={3} gutter="12px" style={{ width: "50%" }}>
        {dialNumbersArray.map((number, index) => {
          return (
            <Button
              key={index}
              sx={{
                padding: "10px",
                margin: "5px",
                fontSize: "1.2rem",
                bgcolor: "#444242",
                color: "#fff",
                width: "100%",
                height: "100%",
              }}
              onClick={handleDialPadNumbers(number)}
            >
              {number === "del" ? <BackspaceIcon /> : number}
            </Button>
          );
        })}
      </Masonry>

      <Stack direction="row" spacing={2}>
        <CustomButton
          variant="outlined"
     sx={{
                display: "flex",
                marginLeft: "auto",
                marginY: 2,
                minWidth: "80px !important",
                backgroundColor: isLightMode
                  ? "var(--secondary-color)"
                  : "var(--primary-color)",
                color: isLightMode
                  ? "var(--text-light-color)"
                  : "var(--text-dark-color)",
                border: isLightMode
                  ? "var(--border-light-color) 1px solid"
                  : "var(--border-dark-color) 1px solid",
                "&:hover": {
                  backgroundColor: isLightMode
                    ? "var(--secondary-color)"
                    : "var(--tertiary-color)",
                  opacity: isLightMode ? 0.85 : 1,
                  // color: isLightMode ? "var(--primary-color)" : "var(--secondary-color)",
                  border: isLightMode
                    ? "var(--border-light-color) 1px solid"
                    : "var(--border-dark-color) 1px solid",
                },
              }}
          onClick={() => handleAddNewShifts("PUNCH_IN")}
        >
          Punch In
        </CustomButton>
        <CustomButton
          variant="outlined"
     sx={{
                display: "flex",
                marginLeft: "auto",
                marginY: 2,
                minWidth: "80px !important",
                backgroundColor: isLightMode
                  ? "var(--secondary-color)"
                  : "var(--primary-color)",
                color: isLightMode
                  ? "var(--text-light-color)"
                  : "var(--text-dark-color)",
                border: isLightMode
                  ? "var(--border-light-color) 1px solid"
                  : "var(--border-dark-color) 1px solid",
                "&:hover": {
                  backgroundColor: isLightMode
                    ? "var(--secondary-color)"
                    : "var(--tertiary-color)",
                  opacity: isLightMode ? 0.85 : 1,
                  // color: isLightMode ? "var(--primary-color)" : "var(--secondary-color)",
                  border: isLightMode
                    ? "var(--border-light-color) 1px solid"
                    : "var(--border-dark-color) 1px solid",
                },
              }}
          onClick={() => handleAddNewShifts("BREAK_IN")}
        >
          Break In
        </CustomButton>

        <CustomButton
          variant="outlined"
     sx={{
                display: "flex",
                marginLeft: "auto",
                marginY: 2,
                minWidth: "80px !important",
                backgroundColor: isLightMode
                  ? "var(--secondary-color)"
                  : "var(--primary-color)",
                color: isLightMode
                  ? "var(--text-light-color)"
                  : "var(--text-dark-color)",
                border: isLightMode
                  ? "var(--border-light-color) 1px solid"
                  : "var(--border-dark-color) 1px solid",
                "&:hover": {
                  backgroundColor: isLightMode
                    ? "var(--secondary-color)"
                    : "var(--tertiary-color)",
                  opacity: isLightMode ? 0.85 : 1,
                  // color: isLightMode ? "var(--primary-color)" : "var(--secondary-color)",
                  border: isLightMode
                    ? "var(--border-light-color) 1px solid"
                    : "var(--border-dark-color) 1px solid",
                },
              }}
          onClick={() => handleAddNewShifts("BREAK_OUT")}
        >
          Break Out
        </CustomButton>
        <CustomButton
          variant="outlined"
     sx={{
                display: "flex",
                marginLeft: "auto",
                marginY: 2,
                minWidth: "80px !important",
                backgroundColor: isLightMode
                  ? "var(--secondary-color)"
                  : "var(--primary-color)",
                color: isLightMode
                  ? "var(--text-light-color)"
                  : "var(--text-dark-color)",
                border: isLightMode
                  ? "var(--border-light-color) 1px solid"
                  : "var(--border-dark-color) 1px solid",
                "&:hover": {
                  backgroundColor: isLightMode
                    ? "var(--secondary-color)"
                    : "var(--tertiary-color)",
                  opacity: isLightMode ? 0.85 : 1,
                  // color: isLightMode ? "var(--primary-color)" : "var(--secondary-color)",
                  border: isLightMode
                    ? "var(--border-light-color) 1px solid"
                    : "var(--border-dark-color) 1px solid",
                },
              }}
          onClick={() => handleAddNewShifts("PUNCH_OUT")}
        >
          Punch Out
        </CustomButton>

      </Stack>
    </StandardCard>
  );
};
